import React from 'react';
import { AxiosInstance } from 'axios';
import useAxios from './useAxios';

interface InjectedAxios {
	axios: AxiosInstance;
}

export default <P extends InjectedAxios>(WrappedComponent: React.ComponentType<P>) => (
	props: Omit<P, keyof InjectedAxios>
) => {
	const axios = useAxios();

	return <WrappedComponent {...(props as P)} axios={axios} />;
};
